export default "__VITE_ASSET__1b4c2a5d__"